<div class="chart-bar">
    <canvas #chart></canvas>
</div>
